<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { validateFields }  from '../base/validation.js';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 
    import ToolTip from '../components/ToolTip.svelte'; 

    let isLoading = false;
    let skuCsvInput;
    let isSkuUploading = false;

    let methodTemp = {
        default : false,
        local_company_uid : "",
        parent_company_uid : "",
        parent_company_label : "",
        shipping_push_supplier_code  : '',
        shipping_push_supplier_code_pickup  : '',
        enable_pickup : "0",
        shipping_pickup_price  : '',
        shipping_free_pickup_above  : '',
        limit_results  : '',
        shipping_push_supplier : '',
        shipping_pull_platform : '', 
        pickup_static_text : "",           
        shipping_push_supplier_token : "",    
        auto_pickup : "0",
        auto_pickup_text : "",
        shipping_push_supplier_username1 : "",
        shipping_push_supplier_username2 : "",
        shipping_push_supplier_username3 : "",
        shipping_push_supplier_password : "",
        method_name_assignment : "",
        method_name_assignment1 : "",
        method_name_assignment2 : "",
        method_name_assignment3 : "",
        sku_assignment : "",
        shipping_push_supplier_auth_username : "",
        shipping_push_supplier_auth_password : "",
    }

    let erp_settings = {};
    let settings = {
        shipping_method : [],
    }

    // onMount(async() => {

    //     await fetchPage(); 
       
    // })    


    const fetchPage = async() => {


        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        } 

        let temp_settings = {}

        let tempCompareMethods = $UserStore?.settings?.shipping_settings?.shipping_method ?? [];


        if (!tempCompareMethods.length && shipping_push_supplier!='') {

            let newMethodTemp = {...methodTemp}   
            newMethodTemp.shipping_push_supplier = shipping_push_supplier  

            $UserStore.settings.shipping_settings.shipping_method = [
                newMethodTemp
            ];


        }



        if ($UserStore.settings && $UserStore.settings.shipping_settings && $UserStore.settings.shipping_settings.shipping_method) {

            for(var key in $UserStore.settings.shipping_settings) {

                settings[key] = $UserStore.settings.shipping_settings[key];

                if (key=='shipping_method') {  
                    
                    if (!Array.isArray(settings[key])) {
                        settings[key] = []

                    } else {     
                        
                        let newMethodTemp = {...methodTemp}                    

                        for(var key2 in settings[key]) {
                            for(var key3 in newMethodTemp) {


                                if (typeof settings[key][key2][key3]==='undefined' && typeof newMethodTemp[key3]!=='undefined') {

                                     settings[key][key2][key3] = newMethodTemp[key3];
                                }



                            } 

                        }

                    }

                    

                }

            }

            settings = {...settings};

            console.log(settings.shipping_method)

        }

    }


    fetchPage(); 



    const handleSubmit = async() => {


        if (!validateFields(settings,2)) {
            
            alert('יש מלא את כל השדות חובה')
            return;
        }

        if (hasTooManySameCompanyAndCustomer()) {
            alert($_('companies.max_two_same_company'));
            return;
        }

        isLoading = true;

        let postData = {};

        postData.action = 'w_update_shipping_methods';
        postData.token = $UserStore.data
        postData.datalogics_shipping_method = settings.shipping_method;

        let response = await fetchData(postData);
        if (response.data) {

            $UserStore.settings = response.data;
            localStorage.setItem('user',JSON.stringify($UserStore))            

            alert('הנתונים נשמרו בהצלחה')

        }



        isLoading = false;


    }

    function validateAndSetSupplierCode(platform_id,value) {

        let inputValue = value;   	

        if (platform_id==62 || platform_id=="62") {

            // Remove non-digits and non-letters
            inputValue = inputValue.replace(/[^0-9a-zA-Z]/g, '');

            // Limit to 4 characters
            inputValue = inputValue.substring(0, 4);


            // Ensure the first two characters are digits
            if (inputValue.length >= 2 && !/^\d{2}/.test(inputValue)) {
                // If the first two characters are not digits, remove them
                inputValue = inputValue.substring(2);
            }  
            
            

        }

        //settings.shipping_push_supplier_code = inputValue.trim();


        return inputValue;

    }

    function detectCsvDelimiter(sampleLine) {
        const delimiters = [',', ';', '\t', '|'];
        let bestDelimiter = ',';
        let bestCount = -1;

        delimiters.forEach((delimiter) => {
            const count = sampleLine.split(delimiter).length - 1;
            if (count > bestCount) {
                bestCount = count;
                bestDelimiter = delimiter;
            }
        });

        return bestDelimiter;
    }

    function parseCsvRows(csvText) {
        const normalizedText = csvText.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        const sampleLine = normalizedText.split('\n').find((line) => line.trim() !== '') || '';
        const delimiter = detectCsvDelimiter(sampleLine);

        const rows = [];
        let currentRow = [];
        let currentField = '';
        let isInsideQuotes = false;

        for (let index = 0; index < normalizedText.length; index += 1) {
            const character = normalizedText[index];
            const nextCharacter = normalizedText[index + 1];

            if (isInsideQuotes) {
                if (character === '"' && nextCharacter === '"') {
                    currentField += '"';
                    index += 1;
                } else if (character === '"') {
                    isInsideQuotes = false;
                } else {
                    currentField += character;
                }
                continue;
            }

            if (character === '"' && currentField === '') {
                isInsideQuotes = true;
                continue;
            }

            if (character === delimiter) {
                currentRow.push(currentField.trim());
                currentField = '';
                continue;
            }

            if (character === '\n') {
                currentRow.push(currentField.trim());
                if (currentRow.some((value) => value !== '')) {
                    rows.push(currentRow);
                }
                currentRow = [];
                currentField = '';
                continue;
            }

            currentField += character;
        }

        if (currentField !== '' || currentRow.length) {
            currentRow.push(currentField.trim());
        }

        if (currentRow.some((value) => value !== '')) {
            rows.push(currentRow);
        }

        return rows;
    }

    function extractSkusFromCsv(csvText) {
        const rows = parseCsvRows(csvText);

        if (!rows.length) {
            return [];
        }

        const headerRow = rows[0].map((value) => value.trim().toLowerCase());
        const skuHeaderCandidates = ['sku', 'skus', 'sku_code', 'sku code', 'product_sku', 'item_sku', 'מק"ט', 'מקט'];
        const skuColumnIndex = headerRow.findIndex((header) =>
            skuHeaderCandidates.some((candidate) => header === candidate || header.includes(candidate.replace(/_/g, ' '))) ||
            header.includes('sku')
        );

        const skuValues = new Set();
        const valueRows = skuColumnIndex >= 0 ? rows.slice(1) : rows;

        valueRows.forEach((row) => {
            const rawValue = skuColumnIndex >= 0 ? row[skuColumnIndex] : row[0];

            if (!rawValue) {
                return;
            }

            rawValue
                .split(/[;,\n]/)
                .map((value) => value.trim())
                .filter((value) => value !== '')
                .forEach((value) => skuValues.add(value));
        });

        return Array.from(skuValues);
    }

    function openSkuCsvPicker() {
        skuCsvInput?.click();
    }

    function createLocalCompanyUid() {
        return `${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    }

    function getCompanyCardLabel(method, index) {
        const platformName = platforms?.[+method?.shipping_push_supplier]?.name ?? '';
        return `${platformName} #${index + 1}`;
    }

    function normalizeCustomerNumber(value) {
        return `${value ?? ''}`.trim();
    }

    function hasTooManySameCompanyAndCustomer() {
        const duplicateCounter = {};

        for (const method of settings.shipping_method) {
            const supplier = `${method?.shipping_push_supplier ?? ''}`.trim();
            const customerNumber = normalizeCustomerNumber(method?.shipping_push_supplier_code);

            // Compare duplicates only when both supplier and customer number exist.
            if (!supplier || !customerNumber) {
                continue;
            }

            const key = `${supplier}::${customerNumber}`;
            duplicateCounter[key] = (duplicateCounter[key] ?? 0) + 1;

            if (duplicateCounter[key] > 2) {
                return true;
            }
        }

        return false;
    }

    async function handleSkuCsvUpload(event) {
        const file = event.currentTarget.files?.[0];
        event.currentTarget.value = '';

        if (!file) {
            return;
        }

        isSkuUploading = true;

        try {
            const csvText = await file.text();
            const extractedSkus = extractSkusFromCsv(csvText);

            if (!extractedSkus.length) {
                alert($_('companies.sku_csv_no_skus'));
                return;
            }

            method.sku_assignment = extractedSkus.join(', ');
            settings = { ...settings };
        } catch (error) {
            console.error(error);
            alert($_('companies.sku_csv_read_failed'));
        } finally {
            isSkuUploading = false;
        }
    }
    

    let selectedPlatform = '';
        let pendingSubCompanyParentIndex = null;
        let subCompanySelectedPlatform = '';


    function addCompany() {

        if (!selectedPlatform) {
            return;
        }
        
        let newMethodTemp = {...methodTemp}
        newMethodTemp.shipping_push_supplier = selectedPlatform;
        newMethodTemp.local_company_uid = createLocalCompanyUid();

        settings.shipping_method.push(newMethodTemp);
        settings = {...settings}
    }

    function addSubCompany(index) {

        pendingSubCompanyParentIndex = index;
        subCompanySelectedPlatform = settings.shipping_method[index]?.shipping_push_supplier ?? '';
    }

    function cancelAddSubCompany() {
        pendingSubCompanyParentIndex = null;
        subCompanySelectedPlatform = '';
    }

    function confirmAddSubCompany() {

        if (pendingSubCompanyParentIndex === null) {
            return;
        }

        const selectedMethod = settings.shipping_method[pendingSubCompanyParentIndex];

        if (!selectedMethod || !selectedMethod.shipping_push_supplier || !subCompanySelectedPlatform) {
            return;
        }

        if (!selectedMethod.local_company_uid) {
            selectedMethod.local_company_uid = createLocalCompanyUid();
        }

        const newMethodTemp = { ...methodTemp };
        newMethodTemp.shipping_push_supplier = subCompanySelectedPlatform;
        newMethodTemp.local_company_uid = createLocalCompanyUid();
        newMethodTemp.is_sub_company = "1";
        newMethodTemp.parent_company_uid = selectedMethod.local_company_uid;
        newMethodTemp.parent_company_label = getCompanyCardLabel(selectedMethod, pendingSubCompanyParentIndex);

        settings.shipping_method.splice(pendingSubCompanyParentIndex + 1, 0, newMethodTemp);
        settings = { ...settings };

        cancelAddSubCompany();
    }

    function removeCompany(index) {

        if (confirm(`${$_('companies.delete_confirmation')}`)) {

            settings.shipping_method.splice(index, 1);

            settings = {...settings}

        }
        
    }
    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">            
            <h1 class="text-[20px] font-bold text-start">
                {#if shippingo=="1" || shippingo=="2"}
                {$_('companies.title')}
                {:else}
                {$_('header.account')}
                {/if}
            </h1>        
            <div class="shipment-flex">
                <div class="shipment_origin">
                    {#if ((shippingo=="2" || shippingo=="1") && Object.keys(platforms).length) || settings.shipping_method.length==0}                    
                    <div class="">
                        <label>{$_('companies.select_shipping_company')}</label>
                        <div class="input_box flex">
                            <div class="input_con w-[300px] flex-none">                                
                                <select bind:value={selectedPlatform}>
                                    <option value="">{$_('companies.choose_company')}</option>
                                    {#each Object.entries(platforms) as [platform_id, platform]}
                                        
                                        <option value="{platform_id}">{platform.name}</option>
                                        
                                    {/each}
                                </select>                                
                            </div> 
                            <div class="create_button w-[100px] flex-none" on:click={ addCompany }>{$_('companies.add')}</div>
                        </div>
                        <div class="mb-5">
                            {#if shippingo=="1"}
                            {$_('companies.shipping_company_not_exist_msg_shippingo')}
                            {:else if shippingo=="2"}
                            {$_('companies.shipping_company_not_exist_msg')}
                            {/if}
                        </div>                        
                    </div>
                    {/if}                    
                    {#each settings.shipping_method as method,index}                        
                        {#if platforms[+method.shipping_push_supplier]}
                        <div
                            class="platform_box relative"
                            class:bg-slate-50={shippingo == '1' || shippingo == '2'}
                            class:hover:bg-slate-100={shippingo === '1' || shippingo == '2'}
                            class:border-[1px]={shippingo == '1' || shippingo == '2'}
                            class:border-slate-300={shippingo == '1' || shippingo == '2'}
                            class:p-4={shippingo === '1' || shippingo == '2'}
                            class:rounded-[5px]={shippingo == '1' || shippingo == '2'}
                            class:mb-5={shippingo == '1' || shippingo == '2'}
                            >
                            {#if shippingo=="1" || shippingo == "2"}
                            <div class="flex w-auto" 
                                    class:justify-between={settings.shipping_method.length>1} 
                                    class:justify-end={settings.shipping_method.length==1}>
                                {#if settings.shipping_method.length>1}
                                <div class="flex items-center gap-1">
                                    <input type="radio" name="company_default{index}" value="{method.default}" class="text-20  w-[20px]">
                                    <label for="company_default{index}">{$_('companies.default')}</label>
                                </div>
                                {/if}
                                <div class="flex gap-2">
                                    <button type="button" on:click={()=> { addSubCompany(index) } } class="pointer border-1 bg-slate-500 rounded-[5px] px-4 py-2 text-white text-center">{$_('companies.add_sub_company')}</button>
                                    <button type="button" on:click={()=> { removeCompany(index) } } class="pointer border-1 bg-slate-700 rounded-[5px] px-4 py-2 text-white text-center">{$_('companies.delete')}</button>
                                </div>
                            </div>
                            <div class="input_box">
                                <h3 class="text-[16px] font-bold">{platforms[+method.shipping_push_supplier].name}</h3>                                
                                {#if method.is_sub_company=="1"}
                                <div class="mt-2 rounded-[6px] border border-sky-200 bg-sky-50 px-2 py-1 text-[12px] text-sky-700">
                                    {$_('companies.sub_company_of')}: {method.parent_company_label || $_('companies.sub_company')}
                                </div>
                                {/if}
                            </div>

                            {#if pendingSubCompanyParentIndex===index}
                            <div class="mt-3 mb-2 rounded-[8px] border border-slate-200 bg-white p-3 shadow-sm">
                                <div class="mb-2 text-[13px] font-bold text-slate-700">{$_('companies.add_sub_company_for')}: {getCompanyCardLabel(method, index)}</div>
                                <div class="input_box mb-2">
                                    <div class="input_con">
                                        <label>{$_('companies.select_sub_company_type')}</label>
                                        <select bind:value={subCompanySelectedPlatform}>
                                            <option value="">{$_('companies.choose_company')}</option>
                                            {#each Object.entries(platforms) as [platform_id, platform]}
                                                <option value="{platform_id}">{platform.name}</option>
                                            {/each}
                                        </select>
                                    </div>
                                </div>
                                <div class="flex gap-2 justify-end">
                                    <button type="button" class="create_button bg-slate-500" on:click={cancelAddSubCompany}>{$_('settings.cancel')}</button>
                                    <button type="button" class="create_button" on:click={confirmAddSubCompany}>{$_('companies.add_sub_company')}</button>
                                </div>
                            </div>
                            {/if}
                            {/if}
                            {#if erp_settings.platform2}
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i>{$_('settings.username')}</label>
                                    <input type="text" bind:value={erp_settings.platform2_username} class:input_empty_error={erp_settings.platform2_username === ''}>
                                </div>      
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('settings.password')}</label>
                                    <input type="text" bind:value={erp_settings.platform2_password} class:input_empty_error={erp_settings.platform2_password === ''}>
                                </div>
                            </div>
                            {/if}

                            {#if method.shipping_push_supplier==58}

                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('settings.customer_number')}</label>
                                    <input type="text" bind:value={method.shipping_push_supplier_code} class:input_empty_error={method.shipping_push_supplier_code === ''}>
                                </div>
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i>AUTH {$_('settings.username')}</label>
                                    <input type="text" bind:value={method.shipping_push_supplier_auth_username} class:input_empty_error={method.shipping_push_supplier_auth_username === ''}>
                                </div>      
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i>AUTH {$_('settings.password')}</label>
                                    <input type="text" bind:value={method.shipping_push_supplier_auth_password} class:input_empty_error={method.shipping_push_supplier_auth_password === ''}>
                                </div>
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('settings.username')}</label>
                                    <input type="text" bind:value={method.shipping_push_supplier_username} class:input_empty_error={method.shipping_push_supplier_username === ''}>
                                </div>      
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('settings.password')}</label>
                                    <input type="text" bind:value={method.shipping_push_supplier_password} class:input_empty_error={method.shipping_push_supplier_password === ''}>
                                </div>
                            </div>

                            {:else if method.shipping_push_supplier==72}

                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('settings.username')}</label>
                                    <input type="text" bind:value={method.shipping_push_supplier_username} class:input_empty_error={method.shipping_push_supplier_username === ''}>
                                </div>      
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('settings.password')}</label>
                                    <input type="text" bind:value={method.shipping_push_supplier_password} class:input_empty_error={method.shipping_push_supplier_password === ''}>
                                </div>
                            </div>


                            {:else if method.shipping_push_supplier==34}

                            <div class="input_box">
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {$_('settings.username')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_username}
                                        class:input_empty_error={method.shipping_push_supplier_username === ''}
                                    />
                                </div>
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {$_('settings.password')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_password}
                                        class:input_empty_error={method.shipping_push_supplier_password === ''}

                                    />
                                </div>
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {$_('settings.customer_number')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_scope}
                                        class:input_empty_error={method.shipping_push_supplier_scope === ''}

                                    />
                                </div>
                            </div>
                            
                            {:else if method.shipping_push_supplier==76}
                            <div class="input_box">
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {$_('settings.username')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_username}
                                        class:input_empty_error={method.shipping_push_supplier_username === ''}
                                    />
                                </div>
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {$_('settings.password')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_password}
                                        class:input_empty_error={method.shipping_push_supplier_password === ''}

                                    />
                                </div>
                            </div>
                                                      
                            {:else if method.shipping_push_supplier==52}
                            <div class="input_box">
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {$_('settings.username')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_username1}
                                        class:input_empty_error={method.shipping_push_supplier_username1 === ''}
                                    />
                                    <label>
                                        {$_('companies.method_name_assignment')}
                                        <ToolTip text={$_('companies.method_name_assignment_desc')}></ToolTip>
                                    </label>
                                    <input type="text" bind:value={method.method_name_assignment1}>

                                </div>
                                <div class="input_con">
                                    <label>
                                        {$_('settings.username2')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_username2}
                                    />     

                                    <label>
                                        {$_('companies.method_name_assignment')}
                                        <ToolTip text={$_('companies.method_name_assignment_desc')}></ToolTip>
                                    </label>
                                    <input type="text" bind:value={method.method_name_assignment2}>

                                </div>
                                <div class="input_con">
                                    <label>
                                        {$_('settings.username3')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_username3}
                                    />
                                    <label>
                                        {$_('companies.method_name_assignment')}
                                        <ToolTip text={$_('companies.method_name_assignment_desc')}></ToolTip>
                                    </label>
                                    <input type="text" bind:value={method.method_name_assignment3}>


                                </div>
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {$_('settings.password')}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_password}
                                        class:input_empty_error={method.shipping_push_supplier_password === ''}

                                    />
                                </div>
                            </div>  
                            
                            {:else}
                            <div class="input_box">
                                <div class="input_con">
                                    <label>
                                        <i class="fa-solid fa-asterisk"></i> 
                                        {#if method.shipping_push_supplier==62} 
                                            {$_('settings.contract_number')}
                                        {:else if method.shipping_push_supplier==54}
                                            {$_('settings.username')}
                                        {:else}
                                            {$_('settings.customer_number')}
                                        {/if}
                                    </label>
                                    <input
                                        type="text"
                                        bind:value={method.shipping_push_supplier_code}
                                        on:input={(event) => method.shipping_push_supplier_code = validateAndSetSupplierCode(method.shipping_push_supplier, event.target.value)}
                                        class:input_empty_error={method.shipping_push_supplier_code === ''}
                                    />
                                </div>
                                {#if method.shipping_push_supplier==17} 
                                    <!-- {#if platforms[+method.shipping_push_supplier] && platforms[+method.shipping_push_supplier]?.pickup=="1"}
                                    <div class="input_con">
                                        <label>
                                            <i class="fa-solid fa-asterisk"></i> 
                                            {$_('settings.customer_number_pickup')}
                                            <p>{$_('settings.customer_number_pickup_notice')}</p>
                                        </label>
                                        <input
                                            type="text"
                                            bind:value={method.shipping_push_supplier_code_pickup}
                                            on:input={(event) => method.shipping_push_supplier_code_pickup = validateAndSetSupplierCode(method.shipping_push_supplier, event.target.value)}
                                            class:input_empty_error={method.shipping_push_supplier_code_pickup === ''}
                                        />
                                    </div>
                                    {/if} -->
                                {/if}

                                {#if method.shipping_push_supplier==54} 
                                    {#if platforms[+method.shipping_push_supplier] && platforms[+method.shipping_push_supplier]?.pickup=="1"}
                                    <div class="input_con">
                                        <label>
                                            <i class="fa-solid fa-asterisk"></i> 
                                            {$_('settings.password')}
                                        </label>
                                        <input
                                            type="text"
                                            bind:value={method.shipping_push_supplier_code_pickup}
                                            on:input={(event) => method.shipping_push_supplier_code_pickup = validateAndSetSupplierCode(method.shipping_push_supplier_code_pickup, event.target.value)}
                                            class:input_empty_error={method.shipping_push_supplier_code_pickup === ''}
                                        />
                                    </div>
                                    {/if}
                                {/if}


                                {#if method.shipping_push_supplier==44} 
                                    {#if platforms[+method.shipping_push_supplier] && platforms[+method.shipping_push_supplier]?.pickup=="1"}
                                    <div class="input_con">
                                        <label>
                                            <i class="fa-solid fa-asterisk"></i> 
                                            {$_('companies.pickup_code')}
                                        </label>
                                        <input
                                            type="text"
                                            bind:value={method.shipping_push_supplier_code_pickup}
                                            on:input={(event) => method.shipping_push_supplier_code_pickup = validateAndSetSupplierCode(method.shipping_push_supplier_code_pickup, event.target.value)}
                                            class:input_empty_error={method.shipping_push_supplier_code_pickup === ''}
                                        />
                                    </div>
                                    {/if}
                                {/if}
                                
                            </div>  
                            {/if}
                            {#if platforms[+method.shipping_push_supplier] && platforms[+method.shipping_push_supplier].token && platforms[+method.shipping_push_supplier].token=="1"}                     
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> 
                                        {#if method.shipping_push_supplier==54} 
                                            {$_('settings.consignee')}                                    
                                        {:else}
                                            {$_('settings.token')}
                                        {/if}
                                    </label>
                                    <input type="text" bind:value={method.shipping_push_supplier_token} class:input_empty_error={method.shipping_push_supplier_token === ''}>
                                </div>
                            </div>  
                            {/if}
                            {#if method.shipping_push_supplier!=52}
                            <div class="input_box">
                                <div class="input_con">
                                    <label>
                                        {$_('companies.method_name_assignment')}
                                        <ToolTip text={$_('companies.method_name_assignment_desc')}></ToolTip>
                                    </label>
                                    <input type="text" bind:value={method.method_name_assignment}>
                                </div>
                            </div>
                            <div class="input_box">
                                <div class="input_con">
                                    <label>
                                        {$_('companies.sku_assignment')}
                                        <ToolTip text={$_('companies.sku_assignment_desc')}></ToolTip>
                                    </label>
                                    <div class="flex gap-2 items-start">
                                        <input type="text" bind:value={method.sku_assignment} class="flex-1">
                                        <input
                                            bind:this={skuCsvInput}
                                            type="file"
                                            accept=".csv,text/csv"
                                            class="hidden"
                                            on:change={handleSkuCsvUpload}
                                        >
                                        <button
                                            type="button"
                                            class="create_button whitespace-nowrap"
                                            on:click={openSkuCsvPicker}
                                            disabled={isSkuUploading}
                                        >
                                            {isSkuUploading ? $_('companies.sku_csv_uploading') : $_('companies.sku_csv_upload')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/if}
                            {#if platforms[+method.shipping_push_supplier] && platforms[+method.shipping_push_supplier].pickup && platforms[+method.shipping_push_supplier].pickup=="1"}
                            <div class="input_box">
                                <div class="input_con radio">
                                    <input id="pudo_enabled1_{method.shipping_push_supplier}" type="radio" name="pudo_enabled{method.shipping_push_supplier}" bind:group={method.enable_pickup} value="1">
                                    <label for="pudo_enabled1_{method.shipping_push_supplier}"><i class="fa-solid fa-asterisk"></i> {$_('settings.using_pudo')}</label>
                                </div>
                                <div class="input_con radio">
                                    <input id="pudo_enabled2_{method.shipping_push_supplier}" type="radio" name="pudo_enabled{method.shipping_push_supplier}" bind:group={method.enable_pickup}  value="0">
                                    <label for="pudo_enabled2_{method.shipping_push_supplier}"><i class="fa-solid fa-asterisk"></i> {$_('settings.not_using_pudo')}</label>
                                </div>
                            </div>
                            {/if}
                            {#if method.enable_pickup=="1"}
                                {#if shippingo == '2'}
                                <div class="py-3">
                                    <h3 class="text-[16px] font-bold">{$_('settings.wordpress_settings')}</h3>
                                </div>
                                <div class="py-2">{@html $_('settings.pudo_explanation_wordpress')}</div>
                                {:else}
                                <div>  
                                    <div class="input_box">                        
                                        <div class="input_con">
                                            <label>{$_('settings.pudo_static_text')}</label>
                                            <input type="text" bind:value={method.pickup_static_text}>
                                        </div>
                                        <div class="input_con">
                                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.pudo_price')}</label>
                                            <input type="text" bind:value={method.shipping_pickup_price}>
                                        </div>
                                        <div class="input_con">
                                            <label>{$_('settings.pudo_free_above')}</label>
                                            <input type="text" bind:value={method.shipping_free_pickup_above}>
                                        </div>                        
                                        <div class="input_con">
                                            <label>{$_('settings.limit_results')}</label>
                                            <input type="text" bind:value={method.limit_results}>
                                        </div>
                                    </div>  
                                    {#if shipping_pull_platform=="39" || shipping_pull_platform=="1"}
                                    <div class="input_box mt-5"> 
                                        <div class="input_con font-bold">
                                            {$_('settings.auto_pickup_desc')}
                                        </div>
                                    </div>

                                    <div class="input_box">    
                                        <div class="input_con">
                                            <label>
                                                <i class="fa-solid fa-asterisk"></i> {$_('settings.auto_pickup')}
                                                <ToolTip text={$_('companies.explain_auto_pickup')}></ToolTip>
                                            </label>
                                            <select bind:value={method.auto_pickup}>
                                                <option value="0">{$_('settings.no')}</option>
                                                <option value="1">{$_('settings.yes')}</option>                                
                                            </select>
                                        </div>
                                        <div class="input_con">
                                            <label>{$_('settings.auto_pickup_text')}</label>
                                            <input type="text" bind:value={method.auto_pickup_text}>
                                        </div>
                                    </div>
                                    
                                    {/if}
                                </div>
                                {/if} 

                                {#if shippingo == '2'}
                                <div class="input_box">    
                                    <div class="input_con">
                                        <label>
                                            <i class="fa-solid fa-asterisk"></i> {$_('settings.view_option')}
                                            <ToolTip text={$_('companies.explain_auto_pickup')}></ToolTip>
                                        </label>
                                        <select bind:value={method.view_option}>
                                            <option value="2">{$_('settings.list')}</option>
                                            <option value="1">{$_('settings.map')}</option>                                
                                        </select>
                                    </div>
                                    {#if method.view_option=="1"}
                                    <div class="input_con">
                                        <label>
                                            <i class="fa-solid fa-asterisk"></i>
                                            {$_('settings.google_key')}
                                        </label>
                                        <input type="text" bind:value={method.google_key} class:input_empty_error={method.google_key === '' || method.google_key==undefined}>
                                    </div>
                                    {:else}                                    
                                    <div class="input_con">
                                        <label>{$_('settings.datalogics_ncode_auto')}</label>
                                        <select bind:value={method.ncode_auto}>
                                            <option value="0">{$_('settings.no')}</option>
                                            <option value="1">{$_('settings.yes')}</option>                                
                                        </select>
                                    </div>
                                    <!-- <div class="input_con">
                                        <label>{$_('settings.cities_auto')}</label>
                                        <select bind:value={method.cities_auto}>
                                            <option value="0">{$_('settings.no')}</option>
                                            <option value="1">{$_('settings.yes')}</option>                                
                                        </select>
                                    </div>
                                    <div class="input_con">
                                        <label>{$_('settings.cities_auto_validation')}</label>
                                        <select bind:value={method.cities_auto_validation}>
                                            <option value="0">{$_('settings.no')}</option>
                                            <option value="1">{$_('settings.yes')}</option>                            
                                        </select>
                                    </div> -->
                                    {/if}
                                </div>
                                {/if}                                
                                
                            {/if} 
                        </div>
                        {/if}                         
                    {/each}
                </div> 
            </div> 
  
            <div class="shipment-flex-button fixed bottom-[20px] z-20 left-0 right-0 m-auto">
                <div class="create_button box-shadow" on:click={ handleSubmit }>{$_('settings.save')}</div>
            </div> 
        </div>
        
    </div>
</div>

